import React from "react";
import { MapPin, PencilSimple } from "@phosphor-icons/react";

import {
  Panel,
  PanelRow,
  PanelRowAction,
  PanelRows,
} from "../../../design-system/patterns/settings";

const formatAddress = (addr) =>
  [
    addr?.address_line1,
    addr?.address_line2,
    addr?.city,
    addr?.province,
    addr?.postal_code,
  ]
    .filter(Boolean)
    .join(", ");

/**
 * The store collection address: where couriers go and what shipping is quoted
 * from. A store has exactly one, separate from the "Default" flag in Saved
 * addresses, which only says what checkout fills in. Pure.
 *
 * WHAT WENT AND WHY
 * -----------------
 * The old version carried a "Shipping preferences" footer reading "Standard
 * Shipping, Signature required for Orders over R1000". Nothing in the API
 * returns either fact; both were hardcoded. The standing copy rule is that we
 * never state a courier, an origin or a shipping price, so a hardcoded shipping
 * promise is exactly the thing that cannot ship. It is deleted, not restyled.
 *
 * The "select a saved address" mode went too. It copied the chosen address over
 * the default row rather than pointing at it, which destroyed an address, and
 * one store address leaves nothing to select between.
 */
const DeliverySection = ({ address, onEdit }) => (
  <Panel
    icon={MapPin}
    title="Store collection address"
    sub="Where couriers collect from you. Changes apply to labels you create after saving."
  >
    <PanelRows>
      <PanelRow
        title={address?.city || "No address yet"}
        detail={formatAddress(address) || "No address provided"}
        actions={
          <PanelRowAction
            icon={PencilSimple}
            label="Edit store collection address"
            onClick={onEdit}
          />
        }
      />
    </PanelRows>
  </Panel>
);

export default DeliverySection;
